import { DecimalPipe } from "@angular/common";
import { DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES, MAIN_SECTION, MAIN_SECTION_LOCALIZED_PROPERTIES, SALES_QUOTATION_LIST_TITLE } from "./quotation-list.constants";
import { ExportFileFormat } from "app/layout/export-overlay";
import { OrderAttributes } from "@albatrosdeveloper/ave-models-package";
import { SalesQuotationListCommonExportProcessor } from "./quotation-list.common";

export class SalesQuotationListExcelExportProcessor extends SalesQuotationListCommonExportProcessor {
  constructor(decimalPipe: DecimalPipe) {
    super(decimalPipe);
  }

  override onInit() {
    this.setSectionTitle(MAIN_SECTION, SALES_QUOTATION_LIST_TITLE);
    if (this.context.format === ExportFileFormat.CSV) {
      this.setSectionOptions(MAIN_SECTION, { ignoreTitleOnOutput: true });
    }
    this.localizeItemProperties(MAIN_SECTION, MAIN_SECTION_LOCALIZED_PROPERTIES);

    this.setSectionTitle(DETAILS_SECTION, 'Detalles');
    this.localizeItemProperties(DETAILS_SECTION, DETAILS_SECTION_LOCALIZED_PROPERTIES);
  }

  override onAddData(item: OrderAttributes) {
    this.addToSection(MAIN_SECTION, this.transformForMainSection(item));
    this.addToSection(DETAILS_SECTION, this.transformForDetailsSection(item));
  }
}
